import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loaderScreenComponent from './loaderScreen.component';
import loaderInterceptor from './loader_interceptor';

let loaderScreenModule = angular.module('loaderScreen', [
  uiRouter
])
  .config(function ($httpProvider) {
    'ngInject';
    $httpProvider.interceptors.push(loaderInterceptor);
  })
  .component('loaderScreen', loaderScreenComponent)
  .name;

export default loaderScreenModule;



// WEBPACK FOOTER //
// ./client/app/components/loaderScreen/loaderScreen.js